export default function (name) {
  let re = new RegExp('(?:(?:^|.*;\\s*)' + name + '\\s*\\=\\s*([^;]*).*$)|^.*$')
  return document.cookie.replace(re, '$1')
}



// WEBPACK FOOTER //
// ./src/utils/cookie.js